function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#EAF0F4",
  d: "M137.8 147.1L3.7 12.4S-9.7-1.9 14.6.2C35.4 2 268.5 22 337.9 28c12.2 1.1 9.1 8 .9 13.1-6.9 4.3-137.8 85.1-178.2 110-13.2 7.9-22.8-4-22.8-4z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BCC8CE",
  d: "M56.1 23.5l168.6 88 23.4 42.3 36.8-79.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#90A4AE",
  d: "M248.1 153.8l-50.3-25.7 26.9-16.6z"
});

function SvgPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "tiny",
    viewBox: "0 0 346 153.8"
  }, props), _ref, _ref2, _ref3);
}

export default SvgPlane;